import Vue from 'vue';
import stockTransformer from './../../transformers/stock';
import store from '../../store';

const success = ({ data }, resolve) => {
  const stock = stockTransformer.fetch(data);
  resolve(stock);
  store.dispatch('fetchCurrentStock', stock);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/stocks/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/stock/show.js